/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type api_v2_analytics_base_FilterItem = {
    column_id: string;
    id: api_v2_analytics_base_FilterItem.id;
    value?: any;
};
export namespace api_v2_analytics_base_FilterItem {
    export enum id {
        EQ = 'eq',
        LT = 'lt',
        GT = 'gt',
        CONTAIN = 'contain',
        EMPTY = 'empty',
        NOT_EMPTY = 'not-empty',
        ERROR = 'error',
        NOT_ERROR = 'not-error',
        IN = 'in',
        NOT_IN = 'not_in',
    }
}

